import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of} from 'rxjs';
import { CacheResolverService } from '../../core/cache/cache-resolver.service';
import { HrmGroup } from '../../core/constants/app.constant';


@Injectable({
  providedIn: 'root',
})
export class HoldService {
  dcSelecetd: BehaviorSubject<[string, string, string]> = new BehaviorSubject< [string, string, string] >([null, null, null]);
  splashmessage: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private readonly cacheService: CacheResolverService) {}

  public isActive(): Observable<boolean> {
    const hrmGroupCheck = this.cacheService.get('hrmGroup');
    if (
      hrmGroupCheck === HrmGroup.DC_EVENTS ||
      hrmGroupCheck === HrmGroup.DC_INVENTORY ||
      hrmGroupCheck === HrmGroup.DC_MANAGEMENT
    ) {
      return of(true);
    }
    return of(false);
  }
}
